import { gql } from '@apollo/client';

export const EXPORT_ACTIVITIES = gql`
  query ExportActivities($input: ExportArgs!) {
    activities: exportActivities(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id

          interventionIds
          interventionNames
          interventionSubjects
          interventionFocusSubjects
          interventionGrades
          interventionStartDate
          interventionEndDate

          attendanceRate
          actualDuration
          attendeeType
          class
          description
          interventionNames
          name
          numberOfAttendees
          numberOfActualSessions
          year
          activityTargets {
            id
            endDate
            groupingType
            numberOfSessions
            expectedNumberOfAttendees
            plannedDuration
            startDate
            cohort {
              id
              name
            }
            frequency {
              id
              name
            }
            frequencyType {
              id
              name
            }
            institution {
              id
              name
            }
          }
          audienceSize {
            name
          }
          audienceType {
            name
          }
          grades {
            name
          }
          groupInstitutions {
            name
          }
          groupCohorts {
            name
          }
          institutions {
            name
          }
          interfaceType {
            name
          }
          inputTypes {
            name
          }
          plannedAttendees
          captureType
          tagNames
          institutionCount
          programmeNames
          programmeIds
          attendanceRate
          serviceProviderNames
          serviceProviderIds
          serviceProviders {
            name
          }
          sessions {
            id
            name
            description
            plannedDuration
            actualDuration
            plannedDate
            actualDate
            institutions {
              id
              name
              emisNumber
            }
            sessionAttendees {
              id
              primaryInstitution {
                id
                name
              }
            }
            sessionStatus
            additionalNotes
          }
          sessionAttendees {
            name
          }
          subjects {
            name
          }
          targetAudiences {
            name
          }
          targetGroup {
            name
          }
          type {
            name
          }
          tags {
            name
          }
          interventions {
            id
            name
            fromDate
            toDate
            gradeValues
            focusSubjectNames
            programme {
              id
              name
            }
            institutions {
              id
              institution {
                id
                emisNumber
                name
              }
            }
            subjects {
              id
              name
            }
            peopleProfiles {
              id
              peopleProfile {
                id
                primaryInstitution {
                  id
                }
                institutions {
                  id
                }
                type {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;
